import { initRouter } from './router.js'
import { initLazy } from './lazy.js'
import { initPage } from './page.js'
import { Header } from 'Components/header/index.js'
import { Loader } from '../../../templates/parts/loader'
import { Datalayer } from '../datalayer/index.js'

export let initialLoad = true
export let header
export let dl

export const initApp = () => {
  dl = new Datalayer()
  new Loader()
  // initRouter()
  initLazy()
  header = new Header()
}

export const setInitialLoad = mode => {
  initialLoad = mode
}
